import React from 'react';

function Check1(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M20.125 2H3.875C2.83982 2 2 2.83982 2 3.875V20.125C2 21.1602 2.83982 22 3.875 22H20.125C21.1602 22 22 21.1602 22 20.125V3.875C22 2.83982 21.1602 2 20.125 2ZM3.875 3.25H20.125C20.4698 3.25 20.75 3.53018 20.75 3.875V20.125C20.75 20.4698 20.4698 20.75 20.125 20.75H3.875C3.53018 20.75 3.25 20.4698 3.25 20.125V3.875C3.25 3.53018 3.53018 3.25 3.875 3.25ZM17.4958 7.98068C17.706 7.70687 17.6544 7.31452 17.3806 7.10434C17.1068 6.89417 16.7144 6.94576 16.5042 7.21957L9.98378 15.7144L7.47163 12.8255C7.24513 12.565 6.85036 12.5375 6.58989 12.764C6.32942 12.9905 6.30189 13.3853 6.52839 13.6457L9.1409 16.65C9.60765 17.1867 10.4491 17.161 10.8822 16.5968L17.4958 7.98068Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Check1;
